<template>
  <div class="main-container mx-auto px-4 md:px-8 lg:px-12 py-10 max-w-7xl">
    <h2
      class="text-[#525355] md:text-[35px] text-2xl font-merriweather font-[900] text-center mb-10"
    >
      Select products to bundle & save.
    </h2>
    
    <div class="flex flex-wrap justify-center">
      <div
        v-for="(option, index) in insuranceOptions"
        :key="option.title"
        :class="{
          'w-[48%] md:w-[31%] xl:w-[23%] m-[1%] md:m-[0.5%] rounded-[5px] drop-shadow-xl hover:shadow flex flex-col items-center bg-white p-2 md:p-6': true,
          'xl:ml-[8%]': index === 4,
          'xl:mr-[8%]': index === 6,
          'xl:ml-[12.5%]': index === 7,
          'xl:mr-[12.5%]': index === 8
        }"
      >
        <div class="flex justify-center items-center w-full h-24">
          <img :src="option.svgSrc" alt="" class="w-24 h-24" />
        </div>
        
        <p class="mb-2 font-merriweather md:text-[25px] text-base text-[#525355] text-center font-bold">
          {{ option.title }}
        </p>
        
        <div class="text-center">
          <template v-if="option.title === 'Home Warranty' || option.title === 'Auto Warranty'">
            <a
              :href="option.quoteLink"
              @click="trackQuoteClick(option.title)"
              class="btn-shadow inline-block font-merriweather sm:text-sm text-[12px] px-[22.5px] py-[7.5px] bg-[#E12F2F] rounded text-white drop-shadow-[-1px_7px_10px_0px_rgb(209,2,2,50)] hover:bg-[#C00202] transition-all duration-500 hover:scale-90"
              target="_blank"
              rel="noopener noreferrer"
            >
              GET A QUOTE
            </a>
          </template>
          <template v-else>
            <router-link
              :to="option.quoteLink"
              @click="trackQuoteClick(option.title)"
              class="btn-shadow inline-block font-merriweather sm:text-sm text-[12px] px-[22.5px] py-[7.5px] bg-[#E12F2F] rounded text-white drop-shadow-[-1px_7px_10px_0px_rgb(209,2,2,50)] hover:bg-[#C00202] transition-all duration-500 hover:scale-90"
            >
              GET A QUOTE
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import SVG images
import homeInsuranceIcon from '@/assets/images/icons/homeInsurance.svg';
import autoInsuranceSvg from '@/assets/images/icons/autoInsurance.svg';
import floodInsuranceSvg from '@/assets/images/icons/floodInsurance.svg';
import medicareSvg from '@/assets/images/icons/medicare.svg';
import lifeInsuranceSvg from '@/assets/images/icons/lifeInsurance.svg';
import petInsuranceSvg from '@/assets/images/icons/petInsurance.svg';
import businessInsuranceSvg from '@/assets/images/icons/businessInsurance.svg';

export default {
  components: {},
  data() {
    return {
      insuranceOptions: [
        {
          title: 'Home Insurance',
          svgSrc: homeInsuranceIcon,
          paddingTop: 'pt-[15%]',
          quoteLink: '/quotes/home?productType=Home Insurance',
        },
        {
          title: 'Auto Insurance',
          svgSrc: autoInsuranceSvg,
          paddingTop: 'pt-[15%]',
          quoteLink: '/quotes/auto?productType=Auto Insurance',
        },
        {
          title: 'Flood Insurance',
          svgSrc: floodInsuranceSvg,
          paddingTop: 'pt-[15%]',
          quoteLink: '/quotes/flood?productType=Flood Insurance',
        },
        {
          title: 'Medicare',
          svgSrc: medicareSvg,
          paddingTop: 'pt-[15%]',
          quoteLink: '/quotes/medicare?productType=Medicare',
        },
        {
          title: 'Life Insurance',
          svgSrc: lifeInsuranceSvg,
          paddingTop: 'pt-[15%]',
          quoteLink: '/quotes/life?productType=Life Insurance',
        },
        {
          title: 'Pet Insurance',
          svgSrc: petInsuranceSvg,
          paddingTop: 'pt-[15%]',
          quoteLink: '/quotes/pet?productType=Pet Insurance',
        },
        {
          title: 'Business Insurance',
          svgSrc: businessInsuranceSvg,
          paddingTop: 'pt-[15%]',
          quoteLink: '/quotes/commercial?productType=Business Insurance',
        },
        {
          title: 'Home Warranty',
          svgSrc: homeInsuranceIcon,
          paddingTop: 'pt-[15%]',
          quoteLink: 'https://fnrh.rateconnex.com/direct/vehicle/type',
        },
        {
          title: 'Auto Warranty',
          svgSrc: autoInsuranceSvg,
          paddingTop: 'pt-[15%]',
          quoteLink: 'https://fnra.rateconnex.com/direct/vehicle/type',
        },
      ],
    };
  },
  methods: {
    trackQuoteClick(insuranceType) {
      this.$gtag.event('click', {
        event_category: 'Get Quote',
        event_label: insuranceType,
      });
    }
  },
};
</script>

<style scoped>
.btn-shadow:hover {
  transform: translateY(1px);
  box-shadow: 0 2px 4px rgba(209, 2, 2, 0.3);
}
</style>
